import util from '../util/util';
export default {
    // 轮播图数据
    section1: {
        // 图片地址
        link: util.get_img('flowtocash_banner.png'),
        // 标题
        title: '有道智选为您提供',
        subtitle: '更品质的流量变现方法',
        // 描述
        description: '',
        cta: '我要变现'
    },
    // 展示块数据
    section2: {
        // 模块名称
        name: '展示',
        data: [
            {
                // 图片地址
                link: util.get_img('model_profit.png'),
                // 标题
                title: '高额收益回报 海量广告资源',
                title_en: 'HIGH PROFIT',
                // 描述
                description: '与一千家以上优质品牌广告主长期合作，保证稳定的广告填充和良好的用户体验。行业领先的媒体收益回报，有道智选不参与分成！让你的流量变现效果可视、收益可观、发展可持续。',
                // 图像位置（居左/居右）
                pos: 'right'
            },
            {
                // 图片地址
                link: util.get_img('model_visualization.png'),
                // 标题
                title: '技术快速接入 后台数据可视',
                title_en: 'DATA VISUALIZATION',
                // 描述
                description: '有道智选为你提供SDK、API等多种便捷的接入方式，并且全程提供技术支持。我们还拥有透明、精准的数据统计后台，便于开发者实时跟踪查看变现收益。',
                // 图像位置（居左/居右）
                pos: 'left'
            },
            {
                // 图片地址
                link: util.get_img('model_ad.png'),
                // 标题
                title: '追求用户体验 构建内容生态',
                title_en: 'CONTEXTUAL  AD',
                // 描述
                description: '为媒体提供基于用户场景的内容广告样式，匹配上百人的专业设计师团队，严格把关广告素材质量。有道智选始终坚持只做最优质的广告与最精选的内容，邀您一起探索更多变现的可能性。',
                // 图像位置（居左/居右）
                pos: 'right'
            },
            {
                // 图片地址
                link: util.get_img('model_service.png'),
                // 标题
                title: '贴心专业服务 响应快速精准',
                title_en: 'PROFESSIONAL SERVICE',
                // 描述
                description: '专业媒介顾问全程跟进服务，审核结算流程快速精准，资深数据分析师提供流量变现策略指引，创意设计师提供定制化的广告位demo设计供你挑选。全方位覆盖你的所有运营需求。',
                // 图像位置（居左/居右）
                pos: 'left'
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/data/flow.js